export const SESSION_USER = 'napcobranzas'
export const SESSION_CLIENT = 'currentclientnapcobranzas'
